import React from "react";
import useAlertStore, { Alert, AlertType } from "../store/useAlertStore";
import styles from "./GlobalAlert.module.css";

const alertClassMap: Record<AlertType, string> = {
  success: styles.success,
  error: styles.error,
  warning: styles.warning,
  info: styles.info,
};

const iconMap: Record<AlertType, string> = {
  success: "✓",
  error: "!",
  warning: "!",
  info: "i",
};

const AlertItem = ({ alert }: { alert: Alert }) => {
  const hideAlert = useAlertStore((state) => state.hideAlert);
  const visibilityClass = alert.isVisible ? styles.visible : styles.hidden;

  return (
    <div
      className={`${styles.alertItem} ${alertClassMap[alert.type]} ${visibilityClass}`}
      role={alert.type === "error" ? "alert" : "status"}
      aria-live={alert.type === "error" ? "assertive" : "polite"}
    >
      <div className={styles.icon} aria-hidden="true">
        {iconMap[alert.type]}
      </div>

      <div className={styles.content}>
        {alert.title && <div className={styles.title}>{alert.title}</div>}
        <div className={styles.message}>{alert.message}</div>

        {alert.details.length > 0 && (
          <ul className={styles.details}>
            {alert.details.map((detail, index) => (
              <li key={`${alert.id}-detail-${index}`}>{detail}</li>
            ))}
          </ul>
        )}
      </div>

      <button
        type="button"
        className={styles.closeButton}
        aria-label="Close alert"
        onClick={() => hideAlert(alert.id)}
      >
        ×
      </button>
    </div>
  );
};

const GlobalAlert: React.FC = () => {
  const alerts = useAlertStore((state) => state.alerts);

  if (alerts.length === 0) return null;

  return (
    <div className={styles.alertContainer} aria-label="Notifications">
      {alerts.map((alert) => (
        <AlertItem key={alert.id} alert={alert} />
      ))}
    </div>
  );
};

export default GlobalAlert;
